import { GraphQLError } from 'common/gql/GraphQLError';

enum CHECK_BALANCE_FORM_ERROR_CODE {
  INVALID_PIN = 'INVALID_PIN',
  GIFT_CARD_NOT_FOUND = 'GIFT_CARD_NOT_FOUND',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  CHALLENGE_VALIDATION_FAILED = 'CHALLENGE_VALIDATION_FAILED',
  PIN_TRIES_EXCEEDED = 'PIN_TRIES_EXCEEDED',
}

const CHECK_BALANCE_FORM_ERROR_CODES = Object.values(CHECK_BALANCE_FORM_ERROR_CODE);

interface CheckBalanceFormGraphQLError extends GraphQLError {
  extensions: {
    code: CHECK_BALANCE_FORM_ERROR_CODE;
  };
}

const isCheckBalanceFormError = (error: unknown): error is CheckBalanceFormGraphQLError =>
  error instanceof GraphQLError &&
  CHECK_BALANCE_FORM_ERROR_CODES.includes(error.extensions.code as CHECK_BALANCE_FORM_ERROR_CODE);

const getCheckBalanceFormErrorFromCode = (code: CHECK_BALANCE_FORM_ERROR_CODE) =>
  `h24_check_gc_balance_form_error_${code.toLowerCase()}`;

export const getCheckBalanceFormErrorMessage = (error: unknown) => {
  if (isCheckBalanceFormError(error)) {
    const errorCode = error.extensions.code;

    switch (errorCode) {
      case CHECK_BALANCE_FORM_ERROR_CODE.INVALID_PIN:
      case CHECK_BALANCE_FORM_ERROR_CODE.GIFT_CARD_NOT_FOUND:
      case CHECK_BALANCE_FORM_ERROR_CODE.RATE_LIMIT_EXCEEDED:
      case CHECK_BALANCE_FORM_ERROR_CODE.CHALLENGE_VALIDATION_FAILED:
      case CHECK_BALANCE_FORM_ERROR_CODE.PIN_TRIES_EXCEEDED:
        return getCheckBalanceFormErrorFromCode(errorCode);
      default:
        return 'h24_something_went_wrong';
    }
  }

  return 'h24_something_went_wrong';
};
